import React from "react";
import styles from "./Tile.module.css";

export default function Tile({ children, className }) {
	return <div className={`${styles.tile} ${className}`}>{children}</div>;
}
